import axios from "axios";

import { EMBED_CODE_EMAIL_URL, WIDGET_CONFIG_URL } from "./constants";
import { getWidgetApiKeyUrl } from "./utils";

export const queryWidgetApiKey = () =>
  axios.get(getWidgetApiKeyUrl(), { showToastr: false });

export const emailWidgetSnippet = data =>
  axios.post(EMBED_CODE_EMAIL_URL, data);

export const fetchWidgetConfiguration = () => axios.get(WIDGET_CONFIG_URL);

export const updateWidgetConfiguration = ({ id, payload }) =>
  axios.put(`${WIDGET_CONFIG_URL}/${id}`, payload);
